import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=1b2f2bcc&scoped=true&"
var script = {}
import style0 from "./PolicyPrivacy.vue?vue&type=style&index=0&id=1b2f2bcc&scoped=true&lang=css&"
import style1 from "./PolicyPrivacy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f2bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
